import { render, staticRenderFns } from "./OrderInfoDropoff.vue?vue&type=template&id=cef04ad8&scoped=true&"
import script from "./OrderInfoDropoff.vue?vue&type=script&lang=js&"
export * from "./OrderInfoDropoff.vue?vue&type=script&lang=js&"
import style0 from "./OrderInfoDropoff.vue?vue&type=style&index=0&id=cef04ad8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cef04ad8",
  null
  
)

export default component.exports